import { render, staticRenderFns } from "./LffSoftSkills.vue?vue&type=template&id=ef51537e&scoped=true&"
import script from "./LffSoftSkills.vue?vue&type=script&lang=js&"
export * from "./LffSoftSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef51537e",
  null
  
)

export default component.exports